import React, { Component } from "react";
import PropTypes from "prop-types";

export default class Select extends Component {
  static propTypes = {
    multiple: PropTypes.bool,
    options: PropTypes.any.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.func
  };

  onChange = e => {
    const { multiple, onChange } = this.props;
    if (multiple) {
      const { options } = e.target;
      const value = [];
      for (const option of options) {
        option.selected && value.push(option.value || option.text);
      }
      onChange(value);
    } else {
      const { value } = e.target;
      onChange(value);
    }
  };

  renderOption = (option, i) => {
    if (option.options) {
      return (
        <optgroup key={option.label || i} label={option.label}>
          {option.options.map(this.renderOption)}
        </optgroup>
      );
    } else {
      return (
        <option key={option.value || i} value={option.value}>
          {option.text}
        </option>
      );
    }
  };

  render() {
    const { multiple = false, options, value } = this.props;

    return (
      <div className="select">
        <select
          className="form-control"
          value={value}
          onChange={this.onChange}
          multiple={multiple}
        >
          {(options || []).map(this.renderOption)}
        </select>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/fields/Select.js